<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        color="error"
        v-on="on"
        v-bind="attrs"
        small
        :block="$mq == 'sm'"
        >Cancelar Inclusão/Alteração</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 font-weight-bold primary--text">
        Cancelar Inclusão/Alteração
      </v-card-title>
      <v-card-text class="mt-3">
        <span class="subtitle-1"
          >Cancelar a inclusão/alteração do dependente
          <b>{{ dependente.nome }}</b> ?</span
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          text
          color="success"
          @click="cancelarDependente()"
          :loading="cancelando"
          >Sim</v-btn
        >
        <v-btn
          rounded
          text
          color="error"
          @click="dialog = false"
          :loading="cancelando"
          >Não</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  props: {
    dependente: Object,
  },
  computed: mapState("dependentes", ["dependentes"]),
  data: () => ({
    dialog: false,
    cancelando: false,
  }),
  methods: {
    ...mapActions("dependentes", ["getDependentes"]),
    async cancelarDependente() {
      this.cancelando = true;

      await axios
        .get(
          `/colaborador/dependentes?funcao=cancelarmovto&codigo=${this.dependente.codatestado}`
        )
        .then(async (res) => {
          if (res.data.success) {
            this.dialog = false;
            await this.getDependentes("");
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));

      this.cancelando = false;
    },
  },
};
</script>

<style>
</style>